import { PracticeBlock } from '../customize_practice_form_modal/types';

export interface SegmentSliceProps {
  number: number;
  title: string;
  estimatedTimeMinutes: number;
  blocks: (SliceLesson | SlicePractice)[];
  openModal: (practiceBlocks: PracticeBlock[]) => void;
  segmentIsLocked: boolean;
}

enum BlockStates {
  complete = 'complete',
  incomplete = 'incomplete',
  start = 'start'
}

export type StateIconType = { [key in keyof typeof BlockStates]: React.ReactNode };
export interface SliceLesson {
  id: number;
  lessonId: number;
  type: 'Lesson';
  estimatedTimeMinutes: number;
  firstIncomplete: boolean;
  state: BlockStates;
}

export interface SlicePractice {
  id: number;
  type: 'Practice';
  practiceBlocks: PracticeBlock[];
  firstIncomplete: boolean;
  state: BlockStates;
}

export interface SliceButton {
  buttonVariant: React.ReactNode;
  buttonCTA: string;
  buttonOnclick: () => void;
}
